import axios from 'axios';

import { getApiUrl } from '../config/urls';

const API_URL = getApiUrl();

/**
 * Récupère un itinéraire entre deux points
 * @param {Object} start - Point de départ { lat, lng }
 * @param {Object} end - Point d'arrivée { lat, lng }
 * @returns {Promise<Object>} Données de l'itinéraire
 */
export const getRoute = async (start, end) => {
  try {
    if (!start || !end || !start.lat || !start.lng || !end.lat || !end.lng) {
      throw new Error('Coordonnées de départ et d\'arrivée requises');
    }

    const coordinates = `${start.lng},${start.lat};${end.lng},${end.lat}`;
    
    const response = await axios.get(`${API_URL}/route`, {
      params: { coordinates },
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'itinéraire:', error);
    throw error;
  }
};

/**
 * Calcule la distance et la durée entre deux points
 * @param {Object} start - Point de départ { lat, lng }
 * @param {Object} end - Point d'arrivée { lat, lng }
 * @returns {Promise<{distance: number, duration: number}>} Distance en mètres et durée en secondes
 */
export const calculateRouteInfo = async (start, end) => {
  try {
    const routeData = await getRoute(start, end);
    const firstRoute = routeData.routes?.[0];
    
    if (!firstRoute) {
      throw new Error('Aucun itinéraire trouvé');
    }

    return {
      distance: firstRoute.distance, // en mètres
      duration: firstRoute.duration  // en secondes
    };
  } catch (error) {
    console.error('Erreur lors du calcul de l\'itinéraire:', error);
    throw error;
  }
};

export default {
  getRoute,
  calculateRouteInfo
};
